(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flx-base"] && !Shopify.designMode) return;
  try {
    if (window.__flxUI) return;
  window.__flxUI = true;
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function fmt(n, dec) {
    var s = Number(n).toFixed(dec);
    if (dec === 0) s = Number(s).toLocaleString('en-GB');
    return s;
  }

  /* Figures are stated, not counted up: they show their final value straight away */
  function setFigure(el) {
    if (el.__flxCounted) return;
    el.__flxCounted = true;
    var to = parseFloat(el.getAttribute('data-to'));
    if (!isNaN(to)) el.textContent = fmt(to, parseInt(el.getAttribute('data-dec') || '0', 10));
  }

  function reveal(el) {
    if (el.classList.contains('is-in')) return;
    el.classList.add('is-revealing', 'is-in');
    setTimeout(function () { el.classList.remove('is-revealing'); }, 2600);
    if (el.hasAttribute('data-flx-count')) setFigure(el);
    var inner = el.querySelectorAll('[data-flx-count]');
    for (var i = 0; i < inner.length; i++) setFigure(inner[i]);
  }

  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < (window.innerHeight || 800) * 0.94 && r.bottom > 0;
  }

  function setupReveal(scope) {
    var groups = scope.querySelectorAll('[data-flx-stagger]');
    for (var g = 0; g < groups.length; g++) {
      var kids = groups[g].children;
      for (var k = 0; k < kids.length; k++) kids[k].style.setProperty('--flx-i', k);
    }
    var els = scope.querySelectorAll('[data-flx-reveal]:not(.is-in)');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      /* A clipped arch is invisible to the observer, so its parent is watched instead */
      var target = el.getAttribute('data-flx-reveal') === 'arch' && el.parentElement ? el.parentElement : el;
      if (reduce || !io || inView(target)) { reveal(el); continue; }
      (target.__flxReveal = target.__flxReveal || []).push(el);
      io.observe(target);
    }
  }

  /* Scroll-linked motion: one passive listener, one frame at a time, only for what is near the screen.
     Each [data-flx-p] element gets --flx-p from 0 (just below the screen) to 1 (just above it). */
  var live = [], tracked = [], ticking = false, vo = null;
  function progress(el) {
    var r = el.getBoundingClientRect(), vh = window.innerHeight || 800;
    var p = (vh - r.top) / (vh + r.height);
    return p < 0 ? 0 : (p > 1 ? 1 : p);
  }
  function paintScroll() {
    ticking = false;
    for (var i = 0; i < live.length; i++) {
      var el = live[i], p = progress(el);
      el.style.setProperty('--flx-p', p.toFixed(4));
      var paths = el.__flxPaths;
      if (paths) for (var j = 0; j < paths.length; j++) {
        var tp = paths[j], from = parseFloat(tp.getAttribute('data-from') || '0'), to = parseFloat(tp.getAttribute('data-to') || '-50');
        tp.setAttribute('startOffset', (from + (to - from) * p).toFixed(2) + '%');
      }
      var draws = el.__flxDraws;
      if (draws) for (var d = 0; d < draws.length; d++) {
        var a = parseFloat(draws[d].getAttribute('data-start') || '0.15'), b = parseFloat(draws[d].getAttribute('data-end') || '0.7');
        var q = (p - a) / (b - a); q = q < 0 ? 0 : (q > 1 ? 1 : q);
        draws[d].style.strokeDashoffset = (1 - q).toFixed(4);
      }
    }
  }
  function onScroll() { if (!ticking) { ticking = true; window.requestAnimationFrame(paintScroll); } }
  function setupScroll(scope) {
    var els = scope.querySelectorAll('[data-flx-p]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.__flxP) continue; el.__flxP = true;
      el.__flxPaths = el.querySelectorAll('textPath[data-flx-path]');
      el.__flxDraws = el.querySelectorAll('[data-flx-scrolldraw]');
      if (reduce) {
        el.style.setProperty('--flx-p', '0.5');
        for (var d = 0; d < el.__flxDraws.length; d++) el.__flxDraws[d].style.strokeDashoffset = '0';
        continue;
      }
      tracked.push(el);
      if (vo) vo.observe(el); else live.push(el);
    }
    paintScroll();
  }

  /* Story chapters: the sticky arch shows the photograph for the chapter being read */
  function setupChapters(el) {
    if (el.__flx || !('IntersectionObserver' in window)) return; el.__flx = true;
    var steps = el.querySelectorAll('[data-flx-chapter]');
    var media = el.querySelectorAll('[data-flx-chapter-media]');
    var pips = el.querySelectorAll('[data-flx-chapter-pip]');
    function show(n) {
      for (var i = 0; i < media.length; i++) media[i].classList.toggle('is-active', i === n);
      for (var p = 0; p < pips.length; p++) pips[p].classList.toggle('is-active', p === n);
      for (var j = 0; j < steps.length; j++) steps[j].classList.toggle('is-active', j === n);
      var bg = steps[n] && steps[n].getAttribute('data-bg');
      if (bg) el.style.setProperty('--flx-ch-bg', bg);
      el.setAttribute('data-active', n);
    }
    var co = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) show(parseInt(e.target.getAttribute('data-flx-chapter'), 10) || 0);
      });
    }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
    for (var s = 0; s < steps.length; s++) co.observe(steps[s]);
    show(0);
  }

  /* Carousel: scroll-snap track, dots, arrows, gentle autoplay while visible */
  function setupCarousel(el) {
    if (el.__flx) return; el.__flx = true;
    var track = el.querySelector('[data-flx-track]');
    if (!track) return;
    var slides = track.children;
    var dots = el.querySelectorAll('[data-flx-dot]');
    var prev = el.querySelector('[data-flx-prev]');
    var next = el.querySelector('[data-flx-next]');
    var timer = null, paused = false, visible = false;
    function current() {
      var best = 0, bestD = Infinity, left = track.scrollLeft;
      for (var i = 0; i < slides.length; i++) {
        var d = Math.abs(slides[i].offsetLeft - track.offsetLeft - left);
        if (d < bestD) { bestD = d; best = i; }
      }
      return best;
    }
    function go(i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    function paint() {
      var c = current();
      for (var d = 0; d < dots.length; d++) dots[d].setAttribute('aria-current', d === c ? 'true' : 'false');
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
    for (var d = 0; d < dots.length; d++) (function (n) { dots[n].addEventListener('click', function () { go(n); }); })(d);
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    function stop() { paused = true; if (timer) { clearInterval(timer); timer = null; } }
    ['pointerdown', 'touchstart', 'focusin', 'mouseenter', 'wheel'].forEach(function (ev) { el.addEventListener(ev, stop, { passive: true }); });
    var auto = parseInt(el.getAttribute('data-flx-auto') || '0', 10);
    if (auto && !reduce && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible && !paused && !timer) timer = setInterval(function () { go(current() + 1); }, auto);
        if (!visible && timer) { clearInterval(timer); timer = null; }
      }, { threshold: 0.5 }).observe(el);
    }
    paint();
  }

  /* Accordion: smooth open and close for <details class="flx-acc"> */
  function setupAccordion(det) {
    if (det.__flx) return; det.__flx = true;
    var sum = det.querySelector('summary');
    var body = det.querySelector('.flx-acc__body');
    if (!sum || !body || reduce || !body.animate) return;
    sum.addEventListener('click', function (e) {
      e.preventDefault();
      if (det.__anim) det.__anim.cancel();
      if (det.open) {
        var h = body.offsetHeight;
        det.classList.add('is-closing');
        det.__anim = body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 340, easing: 'cubic-bezier(.22,.7,.18,1)' });
        det.__anim.onfinish = function () { det.open = false; det.classList.remove('is-closing'); det.__anim = null; };
      } else {
        det.open = true;
        var h2 = body.offsetHeight;
        det.__anim = body.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 420, easing: 'cubic-bezier(.22,.7,.18,1)' });
        det.__anim.onfinish = function () { det.__anim = null; };
      }
    });
  }

  /* Choice groups: radios that update a link, its label and a swatch colour (leg length, size finder) */
  function setupChoices(el) {
    if (el.__flx) return; el.__flx = true;
    var link = el.querySelector('[data-flx-choice-link]');
    var label = el.querySelector('[data-flx-choice-label]');
    function apply(inp) {
      if (!inp) return;
      if (link && inp.getAttribute('data-url')) link.setAttribute('href', inp.getAttribute('data-url'));
      if (label && inp.getAttribute('data-label')) label.textContent = inp.getAttribute('data-label');
      var sw = inp.getAttribute('data-swatch');
      if (sw) el.style.setProperty('--flx-swatch', sw);
    }
    el.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('input')) return;
      var sync = t.getAttribute('data-flx-sync');
      if (sync) { apply(el.querySelector('[data-flx-colours="' + sync + '"] input:checked')); return; }
      if (t.hasAttribute('data-url')) apply(t);
    });
  }

  /* Sticky call to action (phones): shows whenever the hero buttons are off screen, above or below, and hides at the guarantee and footer */
  function setupSticky(bar) {
    if (bar.__flx || !('IntersectionObserver' in window)) return; bar.__flx = true;
    var anchor = document.getElementById(bar.getAttribute('data-flx-sticky'));
    if (!anchor) return;
    var past = false, nearEnd = false;
    function paint() { bar.classList.toggle('is-shown', past && !nearEnd); }
    new IntersectionObserver(function (en) {
      past = !en[0].isIntersecting; paint();
    }).observe(anchor);
    var enders = document.querySelectorAll('[data-flx-sticky-end], footer, .footer');
    if (enders.length) {
      var eo = new IntersectionObserver(function (en) {
        nearEnd = en.some(function (x) { return x.isIntersecting; }); paint();
      });
      for (var i = 0; i < enders.length; i++) eo.observe(enders[i]);
    }
  }

  function scan(scope) {
    setupReveal(scope);
    setupScroll(scope);
    var c = scope.querySelectorAll('[data-flx-carousel]'); for (var i = 0; i < c.length; i++) setupCarousel(c[i]);
    var a = scope.querySelectorAll('details.flx-acc'); for (var j = 0; j < a.length; j++) setupAccordion(a[j]);
    var ch = scope.querySelectorAll('[data-flx-choices]'); for (var k = 0; k < ch.length; k++) setupChoices(ch[k]);
    var st = scope.querySelectorAll('[data-flx-sticky]'); for (var m = 0; m < st.length; m++) setupSticky(st[m]);
    var sc = scope.querySelectorAll('[data-flx-chapters]'); for (var n = 0; n < sc.length; n++) setupChapters(sc[n]);
  }

  function init() {
    if ('IntersectionObserver' in window && !reduce) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var list = e.target.__flxReveal || [e.target];
          for (var i = 0; i < list.length; i++) reveal(list[i]);
          e.target.__flxReveal = null;
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
      vo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var i = live.indexOf(e.target);
          if (e.isIntersecting && i < 0) live.push(e.target);
          if (!e.isIntersecting && i > -1) live.splice(i, 1);
        });
        onScroll();
      }, { rootMargin: '25% 0px 25% 0px' });
    }
    scan(document);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    root.classList.add('flx-ready');
    /* Safety net: anything already scrolled past is shown, so a missed observer never hides content */
    window.addEventListener('load', function () {
      setTimeout(function () {
        var els = document.querySelectorAll('[data-flx-reveal]:not(.is-in)');
        for (var i = 0; i < els.length; i++) if (els[i].getBoundingClientRect().bottom < (window.innerHeight || 800)) reveal(els[i]);
      }, 2500);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  } catch(e) { console.error(e); }
})();

})();
